import {
  getList,
  userFrozen,
  userReset,
  userUntying,
  miniCancellation,
  getUpdpmi,
  setUpdpmi,
  saveUser,
  checkEmployeeId,
} from './service'

function getParams (state) {
  const {
    pagination: { pageIndex, pageSize },
    search,
    // search: { deptId },
  } = state

  const params = Object.entries(search).reduce(
    (prev, [key, value]) => (value ? { ...prev, [key]: value } : prev),
    { pageIndex, pageSize }
  )

  return {
    ...params,
    // deptId: deptId.length ? deptId[deptId.length - 1] : '',
  }
}

function getInitData () {
  return {
    list: [],
    // 分页数据
    pagination: {
      // 一共多少页
      pageCount: 1,
      // 第几页
      pageIndex: 1,
      // 一页显示多少个
      pageSize: 10,
      // 总个数
      total: 1,
    },
    // 搜索数据
    search: {
      realname: '',
      employeeId: '',
      deptId: [],
    },
  }
}

const state = {
  ...getInitData(),
}

const mutations = {
  setState (state, payload) {
    Object.assign(state, payload)
  },
  setPagination (state, payload) {
    state.pagination = { ...state.pagination, ...payload }
  },
  setSearch (state, payload) {
    state.search = { ...state.search, ...payload }
  },
  restState (state) {
    Object.assign(state, getInitData())
  },
}

const actions = {
  getListBySearchBtn ({ state, commit, dispatch }) {
    commit('setPagination', { ...state.pagination, pageIndex: 1 })

    return dispatch('getList')
  },
  async getList ({ state, commit, dispatch }) {
    const params = getParams(state)

    const lastDeptId = params.deptId.length
    params.deptId = lastDeptId ? params.deptId[lastDeptId - 1] : ''
    console.log(params)

    const res = await getList(params)

    if (res.code === 'success') {
      const { list, total, pageIndex } = res.data
      const { pageSize } = state.pagination

      const count = Math.ceil(total / pageSize)

      const index = count > pageIndex ? pageIndex : count

      commit('setState', {
        list: list.map((val, i) => {
          return {
            ...val,
            index: i + 1 + (index - 1) * pageSize * 1,
          }
        }),
        pagination: {
          ...state.pagination,
          pageCount: count,
          total,
          pageIndex: index,
        },
      })

      if (count !== 0 && count < pageIndex) {
        return dispatch('getList')
      }
    }

    return res
  },
  /**
   * @description:      账户冻结及解冻
   * @param {Object}    数据id
   * @return:           res
   */
  async userFrozen ({ dispatch }, params) {
    const res = await userFrozen(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
  /**
   * @description:      重置账户密码
   * @param {Object}    数据id
   * @return:           res
   */
  async userReset ({ dispatch }, params) {
    const res = await userReset(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
  /**
   * @description:      解除微信绑定
   * @param {Object}    数据id
   * @return:           res
   */
  async userUntying ({ dispatch }, params) {
    const res = await userUntying(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
  /**
   * @description:      注销小程序账户
   * @param {Object}    数据id
   * @return:           res
   */
  async miniCancellation ({ dispatch }, params) {
    const res = await miniCancellation(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
  /**
   * @description:      获取用户权限列表
   * @param {Object}    数据id
   * @return:           res
   */
  async getUpdpmi ({ dispatch }, params) {
    const res = await getUpdpmi(params)

    return res
  },
  /**
   * @description:      设置用户权限
   * @param {Object}    设置的权限
   * @return:           res
   */
  async setUpdpmi ({ dispatch }, params) {
    const res = await setUpdpmi(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
  /**
   * @description:      新增用户
   * @param {Object}    设置的权限
   * @return:           res
   */
  async saveUser ({ dispatch, commit, state }, params) {
    commit('setPagination', { ...state.pagination, pageIndex: 1 })
    const res = await saveUser(params)
    if (res.code === 'success') {
      dispatch('getList')
    }
    return res
  },
  /**
   * @description:           异步校验工号
   * @param {Object}  parms  工号
   * @return:                res
   */
  async checkEmployeeId (store, params) {
    return checkEmployeeId(params)
  },
}

export const userManagement = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default userManagement
